

import Vue from 'vue'
import App from './App'
import router from './router'

import 'bootstrap/dist/css/bootstrap.min.css'

import 'vue-layer-mobile/need/layer.css'
import layer from 'vue-layer-mobile'
import './common/global.less'
import { format } from 'path'
import store from './store'
import AlertPlugin from 'vux/src/plugins/alert/index.js'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'

import './common/rem.js'


Vue.config.productionTip = false
Vue.use(AlertPlugin)
Vue.use(ToastPlugin)
Vue.use(layer)
Vue.use(ConfirmPlugin)




/* eslint-disable no-new */
new Vue({
el: '#app',
router,
store,
components: { App },
template: '<App/>',
methods: {

}

})


// WEBPACK FOOTER //
// ./src/main.js